var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuLoansCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_menu_loans_cards") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "1.28749008e-19 0 19 0 19 2.16515607 2.12023003 2.16515607 2.11870925 12.9982905 0.00323409134 13 1.28749008e-19 2.16515607"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_menu_loans_cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-copy-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(0.500000, 4.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-23-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,14 L21,12 L22,11 L22,15 L2,15 L2,2 L22,2 L22,6 L21,5 L21,3 L3,3 L3,14 L21,14 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75287863,
    y1: 6.5,
    x2: 11.7528786,
    y2: 6.5,
    id: "Line-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75287863,
    y1: 10,
    x2: 9.75287863,
    y2: 10,
    id: "Line-Copy-4",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    cx: 18.5,
    cy: 8.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7775468,11 L18.7775468,10.4873817 C19.1621622,10.4540834 19.4620582,10.3454259 19.6772349,10.161409 C19.8924116,9.97739222 20,9.73729408 20,9.44111462 C20,9.28338591 19.9719335,9.14581143 19.9158004,9.02839117 C19.8596674,8.91097091 19.7796258,8.80713284 19.6756757,8.71687697 C19.5717256,8.6266211 19.4438669,8.54644234 19.2920998,8.47634069 C19.1403326,8.40623905 18.9313929,8.33000351 18.6652807,8.24763407 C18.3991684,8.16526463 18.210499,8.07807571 18.0992723,7.9860673 C17.9880457,7.89405889 17.9324324,7.77181914 17.9324324,7.61934805 C17.9324324,7.44935156 17.9885655,7.31878724 18.1008316,7.2276551 C18.2130977,7.13652296 18.3690229,7.09095689 18.5686071,7.09095689 C18.7702703,7.09095689 18.9298337,7.15448651 19.0472973,7.28154574 C19.1647609,7.40860498 19.2234927,7.58254469 19.2234927,7.80336488 L19.2234927,7.80336488 L19.9781705,7.80336488 C19.9781705,7.45986681 19.8794179,7.18077462 19.6819127,6.96608833 C19.4844075,6.75140203 19.2047817,6.62215212 18.8430353,6.57833859 L18.8430353,6.57833859 L18.8430353,6 L18.3440748,6 L18.3440748,6.57308097 C17.9844075,6.60813179 17.6995842,6.71941816 17.489605,6.90694006 C17.2796258,7.09446197 17.1746362,7.33368384 17.1746362,7.62460568 C17.1746362,8.05397827 17.4168399,8.37819839 17.9012474,8.59726604 C18.0467775,8.6638626 18.2505198,8.73615492 18.512474,8.81414301 C18.7744283,8.89213109 18.9615385,8.97975815 19.0738046,9.07702419 C19.1860707,9.17429022 19.2422037,9.29740624 19.2422037,9.44637224 C19.2422037,9.60585349 19.1803534,9.73378899 19.0566528,9.83017876 C18.9329522,9.92656852 18.7525988,9.97476341 18.5155925,9.97476341 C18.2744283,9.97476341 18.0878378,9.91430074 17.9558212,9.79337539 C17.8238046,9.67245005 17.7577963,9.50157729 17.7577963,9.2807571 L17.7577963,9.2807571 L17,9.2807571 C17,9.62776025 17.1107069,9.9064143 17.3321206,10.1167192 C17.5535343,10.3270242 17.8700624,10.4514546 18.2817048,10.4900105 L18.2817048,10.4900105 L18.2817048,11 L18.7775468,11 Z",
    id: "$",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuLoansCards);
export default __webpack_public_path__ + "sanerret-static/media/ic_menu_loans_cards.2b22a18d4fbf0c367d1bf433dd10ed58.svg";
export { ForwardRef as ReactComponent };